import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: theme.spacing(2),
            '& .MuiTypography-root': {
                padding: '0 !important',
            },
        },
        actionLinksContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'end',
            gap: theme.spacing(1),
        },
    }
})
